import { el } from "./dom.js";
import { buildPage, wrapFragment } from "../export.js";
import { formatHtml, highlight, shortenDataUris } from "../format.js";

export function previewFrame(title) {
  return el("iframe", { class: "preview-frame", title, sandbox: "" });
}

export function showPreview(frame, { html, profile, title }) {
  frame.srcdoc = buildPage({ html, profile, title, mode: "preview" });
}

export function codeView(html, wrapper) {
  const code = el("code", { class: "hljs language-html" });
  code.innerHTML = highlight(shortenDataUris(formatHtml(wrapFragment(html, wrapper))), "html"); // highlight() escapes
  return el("pre", { class: "code-view", tabindex: "0", "aria-label": "Formatted HTML code" }, code);
}
